import Vue from 'vue'
import Vuebar from 'vuebar'
import VueScrollTo from 'vue-scrollto'
import countdown from './countdown'

Vue.use(Vuebar)
Vue.use(VueScrollTo)
Vue.directive('countdown', countdown)
